import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { getAideCopropriete } from '../../../../config/aides-coproprietes';

export default function AidesLocalesCoproPage() {
  const aide = getAideCopropriete('aides-locales');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="coproprietes" />;
}
